module.exports = __webpack_public_path__ + "static/media/294101.471dbb02.png";